// ═══ QUIÉN ES EL ADMINISTRADOR DE LA PLATAFORMA ═════════════════════════════
//
// UNA SOLA LISTA. La necesitan dos mundos: el navegador —para decidir si se pinta
// el panel de administrador— y el servidor —`api/avisos-checador.js`, que manda al
// dueño el aviso de leads nuevos—. Dos copias de esta lista es de las peores cosas
// que pueden pasar en este archivo: si una se queda vieja, o el panel se le abre a
// quien no debe, o los avisos se van a un correo que ya no es de nadie. Y nadie las
// vería discrepar, porque cada una corre en un sitio distinto.
//
// NO HAY NADA DE REACT NI DE FIREBASE AQUÍ. Es una lista de textos y una
// comparación, por eso se puede compartir tal cual.
//
// El correo se compara SIEMPRE en minúsculas y sin espacios: Firebase Auth
// conserva las mayúsculas que el usuario tecleó al registrarse, así que comparar
// en crudo dejaría fuera al propio administrador por escribir su correo con una
// mayúscula.
const ADMIN_EMAILS = ["ivan.lopez.15@hotmail.com"];

const _norm = (e) => String(e || "").toLowerCase().trim();

function esAdmin(email) {
  const c = _norm(email);
  return !!c && ADMIN_EMAILS.some((a) => _norm(a) === c);
}

// Se exporta con `exports.X = X`, uno por uno, igual que `checador.js`: es la
// forma que detecta con certeza el lexer que Node usa cuando un ESM importa un
// CJS, y así el archivo sirve para los dos mundos sin depender de cómo decida
// cargarlo nadie.
exports.ADMIN_EMAILS = ADMIN_EMAILS;
exports.esAdmin = esAdmin;
